import ImageryDate from 'components/DisplayEnergy/ImageryDate';
import { ImageryIcon, SolarDataIcon } from 'assets/svg';
import { forwardRef, useEffect, useLayoutEffect, useRef } from 'react';
import Button from 'components/Basic/Button';
import { RootState } from 'store';
import { useMemo } from 'react';
import { getRoofAttrsData } from 'components/DisplayRoofData/utils';
import { useDispatch, useSelector } from 'react-redux';
import DesignModesSelector from 'components/ModeSelector';
import {
	EditFacetModalBtnWrap,
	PanelDetailDiv,
	DesktopViewWrap,
	DivSolarImagery,
	DesktopSidePanel,
	ModeToggleDiv, DesktopViewFixed,
	RightSidePanel

} from './style';
import FacetListButton from 'components/ManualToolModal/facetListBtn';
import TotalGutterLengthLinearFt from 'components/FacetInputs/TotalGutterLengthLinearft';
import TotalAreaSqFt from 'components/FacetInputs/TotalAreaSqFt';
import ShowFacetLabelsToggle from 'components/DisplayRoofData/showFacetLabelsToggle';
import SaveRoofDesignBtn from 'components/DisplayRoofData/SaveRoofDesignBtn';
import { useRefDispatch } from 'contexts/RefContext';
import { toggleFullViewSidePanel } from 'store/slices/ToolSlice';
import { InteractionBlocker } from 'components/InteractionBlocker/interactionBlockerLayer';
import { DESIGN_MODES } from '../../../../constants';
import CustomMapSelect from 'components/CustomMapSelect';
import { selectFilteredGutterLines } from 'store/slices/RoofDataSlice/roofSelector';

const RoofDesktopView = forwardRef<HTMLDivElement>((_props, ref) => {
	const { uuid, roofSegsFromWhichUserHasSelectedPanels, panel, org, mode, imageryCapturedDate,
		lidarCapturedDate, roofDataChanging, autoSwitchStatus, billingLogs, modeAndItsCorrespondingImagery,
		allRoofSegs, roofDesignMode,
	} = useSelector((state: RootState) => ({
		...state.roofData.data,
		roofDataChanging: state.roofData.configuringNewPanel || state.roofData.loading || state.roofData.switchingImageryProvider,
	}));
	const { energyDerateRate, stateCode, toolType, showLidarDate } = useSelector((state: RootState) => state.QueryParams.data);
	const { roofIndexes, editModeEnabled, fullScreenEnabled, fullViewSidePanel } = useSelector((state: RootState) => state.toolNewPostions.data);
	const someFacetIsStillInEditMode = roofSegsFromWhichUserHasSelectedPanels.filter((ind) => roofIndexes.includes(ind));
	const disableOnEdit = editModeEnabled || !!someFacetIsStillInEditMode.length;

	const filteredGutterLines = useSelector(selectFilteredGutterLines);
	const roofDesignData = useMemo(
		() => getRoofAttrsData(allRoofSegs,filteredGutterLines), [filteredGutterLines, allRoofSegs]);

	const desktopViewWrapRef = useRef<HTMLDivElement | null>(null);
	const fullviewSideToggleClicked = useRef(false);
	const isFullScreenSideModelMinimized = fullScreenEnabled && !fullViewSidePanel;
	const isFullScreenSideModelMaximized = fullScreenEnabled && fullViewSidePanel;

	const dispatch = useDispatch();
	const refDispatch = useRefDispatch();

	useLayoutEffect(() => {
		refDispatch({ type: 'ADD_DESKTOP_VIEW_WRAP_REF', payload: { ref: desktopViewWrapRef } });
	}, [refDispatch]);

	const handleToggleMinimize = () => {
		fullviewSideToggleClicked.current = true;
		dispatch(toggleFullViewSidePanel({ enabled: !fullViewSidePanel }));
	};

	useEffect(() => {
		fullviewSideToggleClicked.current = false;
	}, [fullScreenEnabled]);

	return (
		<RightSidePanel
			ref={ref}
			className={`${fullScreenEnabled ? 'fullScreenView' : 'defaultScreenView'}
             ${fullScreenEnabled ? (fullViewSidePanel ? 'fullScreenMax' : 'fullScreenMin') : ''}	
			`}>
			{isFullScreenSideModelMinimized &&
				<Button
					onClick={handleToggleMinimize}
					className={`toggleModeFullscren roofToggleMode  ${fullViewSidePanel ? ' toggleMaximizeBtn' : ' toggleMinizedBtn'}`}
				>
					<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" aria-hidden="true">
						<path fill="none" stroke="var(--defaultIconColor)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
							d="M7 7l5 5-5 5M13 7l5 5-5 5" />
					</svg>
				</Button>
			}
			<DesktopViewFixed 
				ref={desktopViewWrapRef}
				fullScreenEnabled={fullScreenEnabled}
				className={` 
				${fullScreenEnabled ? 'fullScreenView' : 'defaultScreenView'} 
				${fullViewSidePanel ? 'screenMax' : 'screenMini'} 
				${(fullScreenEnabled && !fullviewSideToggleClicked.current ? 'hideMinTansition' : '')}
				`}>
				<DesktopSidePanel
					className={` ${fullScreenEnabled ? 'fullViewMode' : 'defaultScreenView'} ${fullViewSidePanel ? 'fullscreenViewMaximize' : 'fullScreenViewMinized'}`}>
					{isFullScreenSideModelMaximized && <ModeToggleDiv className={`${fullViewSidePanel ? 'modeMaximize' : 'modeMinized'}`}>
						<Button
							onClick={handleToggleMinimize}
							className="toggleModeFullscren"
						>
							{fullViewSidePanel &&
								<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" aria-hidden="true">
									<path fill="none" stroke="var(--defaultIconColor)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
										d="M17 7l-5 5 5 5M11 7l-5 5 5 5" />
								</svg>
							}
						</Button>
					</ModeToggleDiv>
					}
					<InteractionBlocker>
						{(!org.setting.isB2C) &&
							<DesktopViewWrap
								className={`${fullScreenEnabled ? 'fullscreeview-wrap' : 'screeview-wrap'}`}>

								{/* FOR B2B */}

								<DesignModesSelector
									roofMode={roofDesignMode}
									designMode={mode}
									designUUID={uuid}
									panelKey={panel.key}
									energyDerateRate={energyDerateRate}
									stateCode={stateCode}
									billingLogs={billingLogs}
									autoSwitchStatus={autoSwitchStatus}
									modeAndItsCorrespondingImagery={modeAndItsCorrespondingImagery}
									designType='ROOF'
									reqToolType={toolType}
								/>
								<EditFacetModalBtnWrap>
									<FacetListButton />
								</EditFacetModalBtnWrap>
								<DivSolarImagery className='solar-imagery-wrap'>
									<ImageryDate label="Imagery" date={imageryCapturedDate} 
										icon={<ImageryIcon width="38" height="38" />} />
									{showLidarDate && <ImageryDate label="LiDAR" date={lidarCapturedDate} 
										icon={<SolarDataIcon width="38" height="38" />} />}
								</DivSolarImagery>
							</DesktopViewWrap>}
						{/* Roofing Details */}
						<DesktopViewWrap className='roof-detail'>
							<PanelDetailDiv className='total-gutter-area-wrap'>
								<TotalGutterLengthLinearFt totalGutterlengthLinearFt={roofDesignData.totalGutterlengthLinearFt} />
								<TotalAreaSqFt totalAreaSqFt={roofDesignData.totalAreaSqFt} />
							</PanelDetailDiv>
						</DesktopViewWrap>
						<DesktopViewWrap className='custom-map-desktop'>
							{ mode === DESIGN_MODES.NEARMAP_NREL_MANUAL && <CustomMapSelect/>}
						</DesktopViewWrap>
						<ShowFacetLabelsToggle />

						<DesktopViewWrap>
							<SaveRoofDesignBtn
								isB2C={!!org?.setting?.isB2C}
								disabled={disableOnEdit || roofDataChanging || !allRoofSegs.length}
							/>
						</DesktopViewWrap>
					</InteractionBlocker>
				</DesktopSidePanel>
			</DesktopViewFixed>
		</RightSidePanel>
	);
});
RoofDesktopView.displayName = 'RoofDesktopView';
export default RoofDesktopView;